"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalConfiguration = /** @class */ (function () {
    function GlobalConfiguration() {
    }
    GlobalConfiguration.silentError = true;
    GlobalConfiguration.debug = false;
    return GlobalConfiguration;
}());
exports.default = GlobalConfiguration;
//# sourceMappingURL=GlobalConfiguration.js.map